/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { DsFormTemplateGroup } from '../models/ds-form-template-group';
import { BydModel } from '@sixense/byd-core-service';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class DsFormTemplateGroupsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Add form template group link.
   *
   * @param projectId the project id
   * @param templateId the template id
   * @param groupId the group id
   * @returns Observable<boolean>
   */
  public addFormTemplateGroupLink(projectId: number, templateId: number, groupId: number) {
    this.path = `/v2/projects/${projectId}/forms/${templateId}/grouprights/${groupId}`;
    return this.put<boolean>();
  }

  /**
   * Remove form template group link.
   *
   * @param projectId the project id
   * @param templateId the template id
   * @param groupId the group id
   * @returns Observable<boolean>
   */
  public removeFormTemplateGroupLink(projectId: number, templateId: number, groupId: number) {
    this.path = `/v2/projects/${projectId}/forms/${templateId}/grouprights/${groupId}`;
    return this.delete<boolean>();
  }

  /**
   * Remove form template group link.
   *
   * @param projectId the project id
   * @param templateId the template id
   * @returns Observable<BydModel<DsFormTemplateGroup>>
   */
  public getFormTemplateGroupLinks(projectId: number, templateId: number): Observable<BydModel<DsFormTemplateGroup>> {
    this.path = `/v2/projects/${projectId}/forms/${templateId}/grouprights`;
    return this.getModels<DsFormTemplateGroup>();
  }

  /**
   * Create DsFormTemplateGroup instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsFormTemplateGroup` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): DsFormTemplateGroup {
    return new DsFormTemplateGroup(jsonObject);
  }
}
